/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';
import UploadButton from 'shared/ui/components/uploader/UploadButton.vue';
import ReportExportModal from 'shared/ui/components/modals/ReportExportModal.vue';
import VideoProcessingStatus from 'shared/ui/components/media/VideoProcessingStatus.vue';

const __vue_script__ = {
    name: 'VideoList',

    components: { VideoProcessingStatus, SmartTable, UploadButton },

    props: {
        event: {
            type: Object,
            required: true
        },

        totalVideos: {
            type: Number,
            required: true
        },

        videos: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            editor: {},
            contents: []
        };
    },

    methods: {
        /**
         * Gets the file size label
         *
         * @param {object} video the video to get the file size label from
         *
         * @returns {string} */
        getFileSize(video) {
            return this.$utils.numbers.humanFileSize(video.file_size);
        },

        /**
         * Go to the selected page
         *
         * @param {Number} page the page to select
         */
        pageChanged(page) {
            this.$emit('page-changed', page);
        },

        /**
         * Returns relative link
         *
         * @param {String} mediaId id of the media
         *
         * @returns {String} relative link
         */
        getLink(mediaId) {
            const eventId = this.event.id;

            const controller = this.$services.blueprint.getControllerByName('video-library', 'details') || {};
            return this.$services.blueprint.getLinkForModule(controller, { eventId, modelId: mediaId });
        },

        openExportModal() {
            const title = this.$t('analytics.reports.videos.title');
            const description = this.$t('analytics.reports.videos.description');

            this.$modal.show(ReportExportModal, {
                title,
                description,
                event: this.event,
                reportName: 'videos',
                icon: 'film',
                iconStyle: 'alt-1'
            }, {
                classes: 'small',
                height: 'auto'
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smart-table',{staticClass:"video-list",attrs:{"items":_vm.videos,"editor":_vm.editor,"event":_vm.event,"total-items":_vm.totalVideos,"track-by":"id"},on:{"next":_vm.pageChanged,"previous":_vm.pageChanged,"select-page":_vm.pageChanged},scopedSlots:_vm._u([{key:"actions",fn:function(ref){return [_c('upload-button',{staticClass:"btn-primary",attrs:{"scope":"video-list","accepted-mimes":['video/mp4']},on:{"uploaded":function (data) { return _vm.$emit('update', data); }}}),_c('a',{staticClass:"btn",on:{"click":function($event){$event.preventDefault();return _vm.openExportModal.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('video_library.actions.download_analytics')))])]}},{key:"headers",fn:function(ref){return [_c('th',{staticClass:"thumbnail"},[_vm._v(_vm._s(_vm.$t("video_library.list.headers.thumbnail")))]),_c('th',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("video_library.list.headers.title")))]),_c('th',{staticClass:"date"},[_vm._v(_vm._s(_vm.$t("video_library.list.headers.upload_date")))]),_c('th',{staticClass:"size"},[_vm._v(_vm._s(_vm.$t("video_library.list.headers.file_size")))]),_c('th',{staticClass:"row-actions"})]}},{key:"row",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"thumbnail"},[_c('div',{staticClass:"outer-wrapper"},[_c('img',{attrs:{"src":item.thumbnailSrc,"alt":item.title}})])]),_c('td',{staticClass:"title ellipsis"},[_c('a',{attrs:{"href":_vm.getLink(item.id)}},[_vm._v(_vm._s(item.title))])]),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm.$utils.time.tsToFormat(item.timestamp, _vm.$const.DEFAULT_DATE_FORMAT)))]),_c('td',{staticClass:"filesize"},[_c('video-processing-status',{attrs:{"video":item,"default-text":_vm.getFileSize(item)}})],1),_c('td',{staticClass:"row-actions"})]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "VideoList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__